import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { GoogleLogo, ShieldCheck, HandHeart } from "@phosphor-icons/react";
import { toast } from "sonner";
import { useAuth } from "../lib/auth";
import Seo from "../components/Seo";

const Login = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  useEffect(() => {
    if (location.state?.unauthorized) {
      toast.error("This account is not authorized for the admin dashboard.");
    }
  }, [location.state]);

  useEffect(() => {
    if (!loading && user?.is_admin) {
      navigate("/admin", { replace: true });
    }
  }, [user, loading, navigate]);

  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center py-20" data-testid="page-login">
      <Seo title="Sign In" noindex />
      <div className="container-x max-w-md">
        <div className="bg-white rounded-2xl border border-ink-100 shadow-[0_8px_30px_rgba(0,0,0,0.04)] p-8 sm:p-10 text-center">
          <div className="mx-auto inline-flex items-center justify-center w-14 h-14 rounded-full bg-primary/10 text-primary">
            <HandHeart size={28} weight="duotone" />
          </div>
          <h1 className="mt-5 font-heading text-3xl font-medium text-ink-900">
            Ministry admin sign-in
          </h1>
          <p className="mt-3 text-ink-700 leading-relaxed text-sm">
            Sign in with your authorized Google account to access prayer
            requests, support submissions, and donation activity.
          </p>

          <button
            onClick={signIn}
            data-testid="login-google-btn"
            className="mt-7 w-full inline-flex items-center justify-center gap-3 bg-ink-900 text-white rounded-full px-6 py-3.5 font-semibold hover:-translate-y-0.5 hover:shadow-lg transition-all duration-300"
          >
            <GoogleLogo size={20} weight="duotone" />
            Continue with Google
          </button>

          <div className="mt-6 flex items-center justify-center gap-2 text-xs text-ink-500">
            <ShieldCheck size={14} weight="duotone" />
            Pre-authorized ministry staff only
          </div>
        </div>

        <p className="mt-5 text-center text-xs text-ink-500">
          If you should have access but don't, please contact the ministry administrator.
        </p>
      </div>
    </div>
  );
};

export default Login;
